import React from 'react'
import PropTypes from 'prop-types'

import ActionText from '../../../../components/ActionText'

import AppLogo from '../../AppLogo'

import { handleLogout } from '../../../../helpers/auth'

import { ROUTES } from '../../../../constants/routes'

import useStyles from './styles'

function SimpleHeaderTemplate({ logoUrl = ROUTES.platformDomain, showLogout = false }) {
  const classes = useStyles()

  const logoutHandler = () => {
    handleLogout()
  }

  return (
    <header className={classes.header}>
      <div className={classes.container}>
        <a href={logoUrl} rel="noreferrer nofollow" className={classes.logo}>
          <AppLogo />
        </a>
        {showLogout && (
          <ActionText className={classes.logoutBtn} onClick={logoutHandler}>
            Logout
          </ActionText>
        )}
      </div>
    </header>
  )
}

SimpleHeaderTemplate.propTypes = {
  logoUrl: PropTypes.string,
  showLogout: PropTypes.bool
}

export default SimpleHeaderTemplate
